import { jsx as m } from "react/jsx-runtime";
import { useFoundation as l, createComponent as c, useClassNames as s, Tag as f } from "@rmwc/base";
import { MDCFormFieldFoundation as p } from "@material/form-field";
const u = (t) => {
  l({
    props: t,
    elements: {},
    foundation: () => (
      // For RMWC, the entire foundation is a noop. Interactions and ripples are controlled
      // on the components themselves
      new p({
        registerInteractionHandler: (e, n) => {
        },
        deregisterInteractionHandler: (e, n) => {
        },
        activateInputRipple: () => {
        },
        deactivateInputRipple: () => {
        }
      })
    )
  });
}, I = c(
  function(e, n) {
    u(e);
    const { alignEnd: o, foundationRef: F, noWrap: r, spaceBetween: a, ...i } = e, d = s(e, [
      "mdc-form-field",
      {
        "mdc-form-field--align-end": o,
        "mdc-form-field--nowrap": r,
        "mdc-form-field--space-between": a
      }
    ]);
    return /* @__PURE__ */ m(f, { ...i, ref: n, className: d });
  }
);
export {
  I as FormField
};
